import { geolocationCalcDistFromUserLocation } from '@/helpers';
import SearchCenterModel from './SearchCenter.model';

export default class SearchCenters {
  constructor(screeningCenters = {}, { centres_disponibles: availableDepartments } = {}) {
    this.serverData = {
      ...screeningCenters,
      items: screeningCenters?.items?.map((val) => {
        const centerAdditionalInfo = availableDepartments
          ?.find(({ internal_id: internaId }) => val.internal_id && internaId === val.internal_id);
        return {
          ...val,
          ...val?.lat_lon && { lon: val?.lat_lon.split(',')[1] },
          ...val?.lat_lon && { lat: val?.lat_lon.split(',')[0] },
          ...centerAdditionalInfo?.prochain_rdv && { nextAppointment: centerAdditionalInfo?.prochain_rdv },
        };
      }),
    };
    this.centers = this.serverData?.items?.map((val) => new SearchCenterModel(val));
    this.shownCenterCount = this.centers?.length ?? 0;
  }

  getCenters() {
    return this.centers;
  }

  filterByDistance({ lat, lon }) {
    if (!lat || !lon) return this;
    this.centers.sort((center1, center2) => {
      if (!center2.getPosLon() || !center2.getPosLat()) {
        return 1;
      }
      return geolocationCalcDistFromUserLocation({ lon: center1.getPosLon(), lat: center1.getPosLat() }, { lat, lon })
      - geolocationCalcDistFromUserLocation({ lon: center2.getPosLon(), lat: center2.getPosLat() }, { lat, lon });
    });
    return this;
  }

  updateShownCenterCount() {
    this.shownCenterCount = this.centers.filter((center) => center.show).length;

    return this;
  }

  static filterByCityCallback(center, city) {
    return center.getCityUid() === city;
  }

  static filterByCenterTypeCallback(center, centerType) {
    return center.establishmentId === centerType;
  }

  // eslint-disable-next-line no-unused-vars
  static moreFilter(center, filters) {
    // Interface in case ur children classes need more filtering
    return center.show;
  }

  combineFilter(filters) {
    const { city, centerType } = filters;

    for (let i = 0; i < this.centers.length; i += 1) {
      const center = this.centers[i];
      center.show = true;

      if (city && city !== '0') {
        if (center.show) {
          center.show = SearchCenters.filterByCityCallback(center, city);
        }
      }

      if (centerType && centerType !== '0') {
        if (center.show) {
          center.show = SearchCenters.filterByCenterTypeCallback(center, centerType);
        }
      }

      if (center.show) {
        center.show = this.constructor.moreFilter(center, filters);
      }
    }

    this.updateShownCenterCount();

    return this;
  }
}
